import {isProperty} from 'libs/utils/utils';
import {BlogPostType} from 'reducers/blog/blogPost/blogPostType';

import {ApplicationStoreType} from 'reducers';

/**
 * Get blog post
 * @param {ApplicationStoreType} store - Application store
 * @returns {BlogPostType} Blog post
 */
export const getBlogPost = (store: ApplicationStoreType): BlogPostType => store.blogPost;

/**
 * Is blog post loaded
 * @param {ApplicationStoreType} store - application store
 * @returns {boolean} - is loaded
 */
export const isBlogPostFulfilled = isProperty('blogPost.status', 'fulfilled');
